<template>
  <CardGraphicTop
    class="card"
    img-alt="Partage des données"
    img-src="/images/family/share-data.svg"
    :show-controls="true"
    :close-click-outside="true"
    :style-image="{ marginTop: '-3.2rem' }"
    :style-content="{ marginTop: '2rem' }"
  >
    <template #title>
      Bonne nouvelle <icon name="fluent-emoji:slightly-smiling-face" />
    </template>

    <p>
      <strong>{{ displayName }}</strong> a accepté le
      <strong>partage de données</strong> avec vous ! Vous pouvez désormais voir
      ses statistiques de révision et ses progès !
    </p>

    <template #footer>
      <EffectParticles />
      <ButtonBase
        :to="memberUrl"
        :rounded="true"
        theme="secondary"
        stroke="n"
        class="button"
        size="small"
        @click="() => dialog.close()"
      >
        Découvrir
      </ButtonBase>
    </template>
  </CardGraphicTop>
</template>
<script setup lang="ts">
interface Props {
  member: FamilyMember;
}
const props = defineProps({
  member: null
});
const dialog = useDialogStore();
const { displayName, memberUrl } = useFamilyMember(toRef(() => props.member));
</script>
<style lang="scss" scoped>
.card {
  justify-self: center;
  width: 32rem;
  box-shadow: rgb(0 0 0 / 16%) 0 10px 36px 0, rgb(0 0 0 / 6%) 0 0 0 1px;
  @include above('l') {
    width: 40rem;
  }
}
</style>
